import { Pipe, PipeTransform, inject } from '@angular/core';
import { IconKey } from '../../../whitelabel/icon-key.enum';
import { IconProviderService } from '../../whitelabel/services/icon-provider.service';

@Pipe({
  name: 'fileTypeIcon',
  standalone: true,
})
export class FileTypeIconPipe implements PipeTransform {
  private iconProviderService = inject(IconProviderService);

  private fileIcons: { [key: string]: string } = {
    PDF: this.iconProviderService.getIcon(IconKey.FileTypePDF),
    DOC: this.iconProviderService.getIcon(IconKey.FileTypeDOC),
    DOCX: this.iconProviderService.getIcon(IconKey.FileTypeDOC),
    MSWORD: this.iconProviderService.getIcon(IconKey.FileTypeMSWORD),
    XLS: this.iconProviderService.getIcon(IconKey.FileTypeExcel),
    XLSX: this.iconProviderService.getIcon(IconKey.FileTypeExcel),
    PPT: this.iconProviderService.getIcon(IconKey.FileTypePPT),
    PPTX: this.iconProviderService.getIcon(IconKey.FileTypePPT),
    JPG: this.iconProviderService.getIcon(IconKey.FileTypeJPG),
    JPEG: this.iconProviderService.getIcon(IconKey.FileTypeJPG),
    WEBP: this.iconProviderService.getIcon(IconKey.FileTypeImage),
    SVG: this.iconProviderService.getIcon(IconKey.FileTypeSVG),
    PNG: this.iconProviderService.getIcon(IconKey.FileTypePNG),
    GIF: this.iconProviderService.getIcon(IconKey.FileTypeGIF),
    TXT: this.iconProviderService.getIcon(IconKey.FileTypeText),
    TEXT: this.iconProviderService.getIcon(IconKey.FileTypeText),
    ODT: this.iconProviderService.getIcon(IconKey.FileTypeText),
    CSV: this.iconProviderService.getIcon(IconKey.FileTypeCSV),
    ZIP: this.iconProviderService.getIcon(IconKey.FileTypeZIP),
    RAR: this.iconProviderService.getIcon(IconKey.FileTypeRAR),
    MP3: this.iconProviderService.getIcon(IconKey.FileTypeMP3),
    WAV: this.iconProviderService.getIcon(IconKey.FileTypeAudio),
    MP4: this.iconProviderService.getIcon(IconKey.FileTypeMP4),
    MOV: this.iconProviderService.getIcon(IconKey.FileTypeMOV),
    AVI: this.iconProviderService.getIcon(IconKey.FileTypeVideo),
    XML: this.iconProviderService.getIcon(IconKey.FileTypeXML),
    'X-ZIP-COMPRESSED': this.iconProviderService.getIcon(IconKey.FileTypeZIP),
    DEFAULT: this.iconProviderService.getIcon(IconKey.FileTypeFile),
  };

  transform(fileType: string): string {
    if (!fileType) {
      return this.fileIcons['DEFAULT'];
    }
    return this.fileIcons[fileType.toLocaleUpperCase() || 'DEFAULT'] || this.fileIcons['DEFAULT'];
  }
}
